import { StatusCodes } from "http-status-codes";
import { DEFAULT_PAGE, DEFAULT_ROWS } from "../domain/constants";
import { ApiResponseStatus } from "../domain/enums/common/ApiResponseStatusEnum";
import { ResponseMessages } from "../domain/enums/common/ResponseMessagesEnum";

export interface CollectionResponse<T, Meta = any> {
    rows: T[];
    totalRows: number;
    totalPages: number;
    meta?: Meta;
}

export interface SimpleResponse {
    status: boolean;
    entityId?: string;
}

export const NullableCollection: CollectionResponse<any> = {
    rows: [],
    totalRows: DEFAULT_ROWS,
    totalPages: DEFAULT_PAGE,
};
export interface ResponseMessageObj {
    id: string;
    messageType: ResponseMessages;
    messageKey: string;
}

export const defaultResponseMessageObj: ResponseMessageObj = {
    id: null,
    messageType: null,
    messageKey: null,
};

export interface ApiErrorSubject {
    status: ApiResponseStatus;
    statusCode: StatusCodes;
    errorKey: string;
}
